module.exports = __webpack_public_path__ + "static/sec2-71dc27d07f46a2e6426a2d1b319f8d50.png";